import React from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import _ from 'lodash';
import TasksActions from '../Redux/TasksRedux';
const FullScreenLoader = loadable(() => import('../Components/Layout/FullScreenLoader'));

type Props = {
  match: Object,
  task: Object,
  getTask: Function,
  organisation: Object,
};

const mapStateToProps = state => ({
  task: state.tasks.task,
  organisation: state.organisation.organisation,
});

const mapDispatchToProps = dispatch => ({
  getTask: (holdingSlug, organisationSlug, familySlug, taskSlug, eventDate) =>
    dispatch(
      TasksActions.getTaskRequest(holdingSlug, organisationSlug, familySlug, taskSlug, eventDate),
    ),
});

const withTask = WrappedComponent => {
  function fetchTask(props: Props) {
    const { task, match, getTask, organisation } = props;
    const {
      task_slug: taskSlug,
      event_date: eventDate,
      holding_slug: holdingSlug,
      organisation_slug: organisationSlug,
      family_slug: familySlug,
    } = match.params;
    const taskIsMissing = !task;
    const taskHasChanged = _.get(task, 'slug') !== taskSlug;
    const dateHasChanged = _.get(task, 'twig_for_date.event_date') !== eventDate;

    if (_.some([taskIsMissing, taskHasChanged, dateHasChanged])) {
      getTask(holdingSlug, organisationSlug, familySlug, taskSlug, eventDate);
      return <FullScreenLoader />;
    }
    return (
      <WrappedComponent
        {...props}
        task={task}
        organisation={organisation || { id: task.organisation_id, slug: organisationSlug }}
      />
    );
  }

  return connect(mapStateToProps, mapDispatchToProps)(fetchTask);
};

export default withTask;
